import 'assets/styles/scss/bootstrap.scss';
import 'assets/styles/css/basic.min.css';
import 'assets/styles/css/dropzone.min.css';
import 'assets/styles/css/app.css';
import 'assets/styles/css/rize.css';
import UseCacheBuster from 'providers/cacheBuster';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Routes from 'routes/index';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

type NewRelicConfig = {
  readonly licenseKey?: string;
  readonly applicationID?: string;
};

let browserAgent: BrowserAgent | null = null;

const getNewRelicConfig = (): NewRelicConfig | null => {
  const env = process.env.REACT_APP_ENV_NAME || 'dev';

  if (env !== 'prod' && env !== 'dev') {
    return null;
  }

  return {
    licenseKey: process.env.REACT_APP_NR_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NR_APP_ID,
  };
};

const initializeNewRelic = () => {
  const nrConfig = getNewRelicConfig();

  if (!nrConfig?.licenseKey || !nrConfig.applicationID || browserAgent) {
    return;
  }

  try {
    browserAgent = new BrowserAgent({
      init: {
        jserrors: {
          enabled: true,
        },
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: nrConfig.licenseKey,
        applicationID: nrConfig.applicationID,
        sa: 1,
      },
      features: [
        {
          spa: true,
        },
      ],
    });
  } catch {
    browserAgent = null;
  }
};

function App() {
  const defaultLang = localStorage.getItem('language');
  const { i18n } = useTranslation();

  useEffect(() => {
    if (defaultLang) {
      void i18n.changeLanguage(defaultLang);
    }
  }, [defaultLang, i18n]);

  useEffect(() => {
    initializeNewRelic();
  }, []);

  return (
    <Router>
      <UseCacheBuster />
      <Switch>
        <Route render={({ location }) => <Routes key={location.pathname} />} />
      </Switch>
    </Router>
  );
}

export default App;
